import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from 'vue-router-multiguard'



import {auth, guest} from './middlewares'

import RegisterPage from '../views/Auth/RegisterPage.vue'
import LoginPage from '../views/Auth/LoginPage.vue'
import Welcome from '../views/Welcome.vue'
import QuotesCreate from '../views/Quotes/Create.vue'
import QuotesRetrieve from '../views/Quotes/Retrieve.vue'
import QuotesIndex from '../views/Quotes/Index.vue'
import UsersConfirm from '../views/Users/Confirm.vue'
import PrintersIndex from '../views/Printers/Index.vue'
import PrintersEdit from '../views/Printers/Edit.vue'
import ResultsIndex from '../views/Results/Index.vue'
import OrdersIndex from '../views/Order/Index.vue'
import OrdersSuccess from '../views/Order/Success.vue'
import ProposalCalculations from '../views/ProposalTemplate/Calculations.vue'
import ProposalSummary from '../views/ProposalTemplate/Summary.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    beforeEnter: multiguard([guest])
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    beforeEnter: multiguard([guest])
  },
  {
    path: '/proposal/calculations/:id',
    name: 'proposal.calculations',
    component: ProposalCalculations,
    beforeEnter: multiguard([]),
  },
  {
    path: '/proposal/summary/:id',
    name: 'proposal.summary',
    component: ProposalSummary,
    beforeEnter: multiguard([]),
  },
  {
    path: '/orders/success',
    name: 'orders.success',
    component: OrdersSuccess,
    beforeEnter: multiguard([]),
  },
  {
    path: '/orders/:id',
    name: 'orders.index',
    component: OrdersIndex,
    beforeEnter: multiguard([]),
  },
  {
    path: '/results/:quote_id',
    name: 'results.index',
    component: ResultsIndex,
    beforeEnter: multiguard([]),
  },
  {
    path: '/printers',
    name: 'printers.index',
    component: PrintersIndex,
    beforeEnter: multiguard([auth]),
  },
  {
    path: '/printers/:id/edit',
    name: 'printers.edit',
    component: PrintersEdit,
    beforeEnter: multiguard([auth]),
  },
  {
    path: '/quotes',
    name: 'quotes.index',
    component: QuotesIndex,
    beforeEnter: multiguard([auth]),
  },
  {
    path: '/quotes-retrieve',
    name: 'quotes.retrieve',
    component: QuotesRetrieve,
    beforeEnter: multiguard([]),
  },
  {
    path: '/quotes-create',
    name: 'quotes.create',
    component: QuotesCreate,
    beforeEnter: multiguard([]),
  },
  {
    path: '/quotes-create?form=callback',
    name: 'quotes.create.callback',
    component: QuotesCreate,
    beforeEnter: multiguard([]),
  },
  {
    path: '/users/confirm/:email',
    name: 'users.confirm',
    component: UsersConfirm,
    beforeEnter: multiguard([]),
  },
  {
    path: '/',
    name: 'home',
    component: Welcome,
    beforeEnter: multiguard([auth])

  },
  {
    path: '*',
    redirect: {name: 'quotes.create'}
  }
]

export default new VueRouter({mode: 'history', routes})



// WEBPACK FOOTER //
// ./src/router/router.js